<template>
    <div class="fixed-bottom text-center app-alert">
        <transition-group
            name="slide-top"
            tag="div"
        >
            <div
                v-for="message of messages"
                :key="message.id"
                class="text-white py-3 h6 m-0 cursor-pointer slide-top-item w-100"
                :class="'bg-' + message.type"
                @click="remove(message.id)"
            >
                {{ message.text }}
            </div>
        </transition-group>
    </div>
</template>

<script>
    import Vue from 'vue'

    export default {
        name: "AlertList",

        data: function () {
            return {
                ids: 1,
                messages: [],
            }
        },

        /**
         * Enregistre la fonction notify disponible depuis l'instance Vue
         */
        created: function () {
            Vue.prototype.$notify = (type, text, millisecondes) => this.show(type, text, millisecondes)
        },

        methods: {
            /**
             * Affiche une notification pendant 8 secondes
             * @param type
             * @param text
             * @param millisecondes
             */
            show: function (type, text, millisecondes = 8000) {
                let id = this.ids++

                this.messages.push({id, type, text})

                setTimeout(() => this.remove(id), millisecondes)
            },

            /**
             * Supprime une notification
             * @param id
             */
            remove: function (id) {
                this.messages = this.messages.filter(notification => notification.id !== id)
            }
        }
    }
</script>
